import React, { Component } from "react";

export default () => {
    return <div>
        Display
    </div>
}